import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d57bd730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analyzes-container" }
const _hoisted_2 = { class: "title header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "能量分析", -1))
const _hoisted_4 = { class: "chart" }

import {
  onMounted,
  shallowRef,
  ref,
  watch,
  PropType,
  computed,
  onUnmounted,
} from 'vue'
import * as echarts from 'echarts'
import DataToggle from './DataToggle.vue'
import { EssEnergyGrowthTrendChartData } from '../../Photovoltaic/types'
import { useEnergyAnalysisStats } from '../useEnergyAnalysisStats'
import { StatisticsTimeGrain } from '@/types/types'
import { hexToRgba } from '@/common/tools'

export default /*#__PURE__*/_defineComponent({
  props: {
  height: {
    type: Number,
    default: 400,
  },
  data: {
    type: Object as PropType<EssEnergyGrowthTrendChartData>,
    default: () => ({}),
  },
  color: {
    type: Array as PropType<string[]>,
    default: () => ['#39f0fa', '#227cf2', '#fa7828', '#32fa61'],
  },
  hasLine: {
    type: Boolean,
    default: true,
  },
  stationId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const dataToggle = ref<'日' | '月' | '年'>('日')

const { fetchEssEnergyAnalysisStats, essEnergyAnalysisStatsChartData } = useEnergyAnalysisStats()

const findType = (toggle: '日' | '月' | '年') => {
  const idx = ['日', '月', '年'].findIndex((i) => i == toggle)
  return [StatisticsTimeGrain.STD_DAY, StatisticsTimeGrain.STD_MONTH, StatisticsTimeGrain.STD_YEAR][
    idx
  ]
}
watch(
  () => dataToggle.value,
  () => {
    fetchEssEnergyAnalysisStats(findType(dataToggle.value), props.stationId)
  },
)
onMounted(() => {
  initChart()
  startIntervalEnergyAnalysisStats()
  fetchEssEnergyAnalysisStats(findType(dataToggle.value), props.stationId)
  window.addEventListener('resize', () => {
    if (echart.value) {
      const chartInstance = echarts.getInstanceByDom(echart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

const echart = ref()
const chart = shallowRef<echarts.ECharts | null>(null)

let setTimeEnergyAnalysisStatsId: ReturnType<typeof setInterval> | null = null

const startIntervalEnergyAnalysisStats = () => {
  setTimeEnergyAnalysisStatsId = setInterval(() => {
    fetchEssEnergyAnalysisStats(findType(dataToggle.value), props.stationId)
    console.log(123)
  }, 30 * 1000)
}

onUnmounted(() => {
  if (setTimeEnergyAnalysisStatsId) {
    clearInterval(setTimeEnergyAnalysisStatsId)
  }
})

watch(
  () => essEnergyAnalysisStatsChartData.value,
  (newData: EssEnergyGrowthTrendChartData) => {
    if (echart.value && newData) {
      const chartInstance = echarts.getInstanceByDom(echart.value)
      console.log()
      if (chartInstance) {
        chartInstance.setOption({
          xAxis: [
            {
              data: newData.xAxisData || [],
            },
          ],
          series: newData.seriesData?.map((series, index) => {
            const rgbCol =
              hexToRgba(props.color[index] ? props.color[index] : '#5e4eff', 0.4) ??
              'rgba(94,78,255, 0.4)'
            return {
              type: 'line',
              smooth: true,
              lineStyle: {
                width: 2,
              },
              showSymbol: false,
              areaStyle: {
                // 区域渐变填充
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: rgbCol,
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 166, 0, 0)',
                  },
                ]),
              },
              name: newData.seriesData ? newData.seriesData[index].name : series.name,
              data: newData.seriesData ? trimEndZeros(newData.seriesData[index].data) : [],
            }
          }),
        })
      }
    }
  },
  { immediate: true, deep: true },
)
function trimEndZeros(arr: number[]): number[] {
  let end = arr.length - 1
  while (end >= 0 && arr[end] === 0) {
    end--
  }
  return arr.slice(0, end + 1)
}

const chartOption = computed(() => {
  return {
    color: props.color,
    grid: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 25,
      containLabel: true, // 如果坐标轴label也不需要显示
    },
    legend: {
      textStyle: {
        color: '#a8d7ff',
      },
      bottom: 0,
    },
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      triggerEvent: true,

      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
      formatter: (params: any) => {
        let unit = 'kWh' // 根据实际单位修改
        let result = params[0]?.axisValueLabel ? `<div>${params[0].axisValueLabel}</div>` : ''
        params.forEach((item: any) => {
          result += `<div>${item.marker}${item.seriesName}: ${item.value} ${unit}</div>`
        })
        return result
      },
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: true,
      },
    },
    series: [
      {
        name: '光伏发电',
        data: [120, 200, 312, 1, 70, 110, 130],
        type: 'line',
        smooth: true,
      },
      {
        name: '光伏发电2',
        data: [120, 200, 123, 180, 70, 110, 130],
        type: 'line',
        smooth: true,
      },
      {
        name: '光伏发电3',
        data: [120, 200, 345, 80, 345, 345, 130],
        type: 'line',
        smooth: true,
      },
    ],
  }
})
const initChart = () => {
  const chartDom = echart.value

  if (chartDom) {
    chart.value = echarts.init(chartDom)
    renderChart()
  }
}

const renderChart = () => {
  if (!chart.value) return
  chart.value.setOption(chartOption.value)
}
const createTooltip = (xAxis: string, val: number | undefined) => {
  const container = document.createElement('div')
  container.className = 'rate-chart-tooltip'
  if (val === undefined) {
    container.innerHTML = `<p class="no-data">noData</p>`
  } else {
    container.innerHTML = `<p>${xAxis}</p>
    <p>${val}</p>`
  }
  return container
}

onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (echart.value) {
      const chartInstance = echarts.getInstanceByDom(echart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

// initChart()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(DataToggle, {
        modelValue: dataToggle.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataToggle).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        ref_key: "echart",
        ref: echart,
        id: "echart",
        style: {"width":"100%","height":"100%"}
      }, null, 512)
    ])
  ]))
}
}

})